import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { updateContainer } from 'PreviewActions';
import { SELECTED_CONTAINER } from 'PreviewConstants/';
import { UI } from 'SharedConstants/';
import { colourWhite, colourPrimary } from 'Styles/colors.css';

const BtnGroup = styled.div`
  padding-top: 15px;
  padding-bottom: 10px;
`;

const Btn = styled.button`
  width: 100%;
  font-size: 14px;
  position: relative;
  float: left;
  line-height: 21px;
  padding: 6px 12px;
  padding-left: 17px;
  padding-right: 17px;
  background: ${colourWhite};
  border: 1px solid #f0f0f0;
  ${props => props.isActive && { background: colourPrimary }};
  ${props => props.isActive && { color: 'white' }};
`;

class ContainerSelector extends Component {
  handleChange = (event) => {
    const { updateContainer } = this.props; // eslint-disable-line no-shadow
    const selectedContainer = event.target.getAttribute('data-container') || event.target.parentNode.getAttribute('data-container');
    updateContainer(selectedContainer);
  };
  render() {
    const { selectedContainer } = this.props;
    const { handleChange } = this;

    const availableContainers = [{ label: 'Responsive', value: 'responsive' }, { label: 'Page', value: 'page' }, { label: 'Custom', value: 'custom' }];

    return (
      <BtnGroup className="btn-group btn-group-justified">
        {availableContainers.map(container => (
          <div key={container.value} className="btn-group">
            <Btn
              type="button"
              isActive={container.value === selectedContainer}
              onClick={handleChange}
              data-container={container.value}
            >
              <span className="fs-11 font-montserrat text-uppercase">{container.label}</span>
            </Btn>
          </div>),
        )}
      </BtnGroup>
    );
  }
}

ContainerSelector.propTypes = {
  selectedContainer: PropTypes.string,
  updateContainer: PropTypes.func,
};

ContainerSelector.defaultProps = {
  selectedContainer: 'standard',
  updateContainer: () => {},
};

const mapStateToProps = state => ({
  selectedContainer: state.getIn([UI, SELECTED_CONTAINER]),
});

const mapDispatchToProps = dispatch => ({
  updateContainer: selectedContainer =>
    dispatch(updateContainer(selectedContainer)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContainerSelector);



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/SideBar/ContainerSelector/ContainerSelector.jsx